import { ImageUp, Trash2 } from "lucide-react";

import { ImageStripActionButton } from "./ImageStripActionButton";

export function ImageStripActions({
    onMoveToFirst,
    onRemove,
}: {
    onMoveToFirst?: () => void;
    onRemove: () => void;
}) {
    return (
        <div className="pointer-events-none absolute top-2 right-2 z-10 flex gap-1 opacity-0 transition-opacity group-[:focus-within]:pointer-events-auto group-[:hover]:pointer-events-auto group-[:focus-within]:opacity-100 group-[:hover]:opacity-100">
            {onMoveToFirst ? (
                <ImageStripActionButton
                    label="Move to first"
                    className="bg-white/90 shadow-sm"
                    onClick={onMoveToFirst}
                >
                    <ImageUp />
                </ImageStripActionButton>
            ) : null}
            <ImageStripActionButton
                label="Delete"
                className="bg-white text-destructive shadow-sm hover:bg-red-50 hover:text-destructive"
                onClick={onRemove}
            >
                <Trash2 />
            </ImageStripActionButton>
        </div>
    );
}
